import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            六大分类，精准导航，快速找到你想要的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {videoCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}+ 部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}